import { render, staticRenderFns } from "./lib-search.component.vue?vue&type=template&id=78fd75b8"
import script from "./lib-search.component.vue?vue&type=script&lang=ts"
export * from "./lib-search.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports